const puertoRico = [
    { "code": "Adjuntas", "name": "Adjuntas" },
    { "code": "Aguada", "name": "Aguada" },
    { "code": "Aguadilla", "name": "Aguadilla" },
    { "code": "Aguas Buenas", "name": "Aguas Buenas" },
    { "code": "Aibonito", "name": "Aibonito" },
    { "code": "Añasco", "name": "Añasco" },
    { "code": "Arecibo", "name": "Arecibo" },
    { "code": "Arroyo", "name": "Arroyo" },
    { "code": "Barceloneta", "name": "Barceloneta" },
    { "code": "Barranquitas", "name": "Barranquitas" },
    { "code": "Bayamón", "name": "Bayamón" },
    { "code": "Cabo Rojo", "name": "Cabo Rojo" },
    { "code": "Caguas", "name": "Caguas" },
    { "code": "Camuy", "name": "Camuy" },
    { "code": "Canóvanas", "name": "Canóvanas" },
    { "code": "Carolina", "name": "Carolina" },
    { "code": "Cataño", "name": "Cataño" },
    { "code": "Cayey", "name": "Cayey" },
    { "code": "Ceiba", "name": "Ceiba" },
    { "code": "Ciales", "name": "Ciales" },
    { "code": "Cidra", "name": "Cidra" },
    { "code": "Coamo", "name": "Coamo" },
    { "code": "Comerío", "name": "Comerío" },
    { "code": "Corozal", "name": "Corozal" },
    { "code": "Culebra", "name": "Culebra" },
    { "code": "Dorado", "name": "Dorado" },
    { "code": "Fajardo", "name": "Fajardo" },
    { "code": "Florida", "name": "Florida" },
    { "code": "Guánica", "name": "Guánica" },
    { "code": "Guayama", "name": "Guayama" },
    { "code": "Guayanilla", "name": "Guayanilla" },
    { "code": "Guaynabo", "name": "Guaynabo" },
    { "code": "Gurabo", "name": "Gurabo" },
    { "code": "Hatillo", "name": "Hatillo" },
    { "code": "Hormigueros", "name": "Hormigueros" },
    { "code": "Humacao", "name": "Humacao" },
    { "code": "Isabela", "name": "Isabela" },
    { "code": "Jayuya", "name": "Jayuya" },
    { "code": "Juana Díaz", "name": "Juana Díaz" },
    { "code": "Juncos", "name": "Juncos" },
    { "code": "Lajas", "name": "Lajas" },
    { "code": "Lares", "name": "Lares" },
    { "code": "Las Marías", "name": "Las Marías" },
    { "code": "Las Piedras", "name": "Las Piedras" },
    { "code": "Loíza", "name": "Loíza" },
    { "code": "Luquillo", "name": "Luquillo" },
    { "code": "Manatí", "name": "Manatí" },
    { "code": "Maricao", "name": "Maricao" },
    { "code": "Maunabo", "name": "Maunabo" },
    { "code": "Mayagüez", "name": "Mayagüez" },
    { "code": "Moca", "name": "Moca" },
    { "code": "Morovis", "name": "Morovis" },
    { "code": "Naguabo", "name": "Naguabo" },
    { "code": "Naranjito", "name": "Naranjito" },
    { "code": "Orocovis", "name": "Orocovis" },
    { "code": "Patillas", "name": "Patillas" },
    { "code": "Peñuelas", "name": "Peñuelas" },
    { "code": "Ponce", "name": "Ponce" },
    { "code": "Quebradillas", "name": "Quebradillas" },
    { "code": "Rincón", "name": "Rincón" },
    { "code": "Río Grande", "name": "Río Grande" },
    { "code": "Sabana Grande", "name": "Sabana Grande" },
    { "code": "Salinas", "name": "Salinas" },
    { "code": "San Germán", "name": "San Germán" },
    { "code": "San Juan", "name": "San Juan" },
    { "code": "San Lorenzo", "name": "San Lorenzo" },
    { "code": "San Sebastián", "name": "San Sebastián" },
    { "code": "Santa Isabel", "name": "Santa Isabel" },
    { "code": "Toa Alta", "name": "Toa Alta" },
    { "code": "Toa Baja", "name": "Toa Baja" },
    { "code": "Trujillo Alto", "name": "Trujillo Alto" },
    { "code": "Utuado", "name": "Utuado" },
    { "code": "Vega Alta", "name": "Vega Alta" },
    { "code": "Vega Baja", "name": "Vega Baja" },
    { "code": "Vieques", "name": "Vieques" },
    { "code": "Villalba", "name": "Villalba" },
    { "code": "Yabucoa", "name": "Yabucoa" },
    { "code": "Yauco", "name": "Yauco" }
  ]
export default puertoRico;